<div
  *ngIf="!isSelectDeviceView && !isPhoneTemplate && !isCellularEnabledTemplate"
  class="pgh-adp-device-card"
  tabindex="-1"
  cdkMonitorSubtreeFocus>
  <div
    class="device-card-container"
    [ngClass]="{'noboxshadow': !hasBoxShadow, 'add-device-card-container': isAddDeviceCard}"
    >
    <div class="device-card-body">
      <div class="device-card-row device-card-row-layout device-card-row-mobile" style="align-items: flex-end">
        <div>
          <button
            *ngIf="hasEdit"
            mat-raised-button
            (click)="handleEditActionClick()"
            [gtmClick]="editIconAriaLabel"
            class="device-card-button"
            [attr.aria-label]="editIconAriaLabel || undefined">
            <span>
              <mat-icon
                [class]="'adp-ds-icon-wrapper'"
                style="width: 16px !important; height: 16px !important"
                width="16"
                height="16"
                svgIcon="device-edit"></mat-icon>
            </span>
          </button>
          <button
            *ngIf="hasDelete"
            mat-raised-button
            (click)="handleDeleteActionClick()"
            [gtmClick]="deleteIconAriaLabel"
            class="device-card-button"
            [attr.aria-label]="deleteIconAriaLabel || undefined"
            style="margin-left: 5px"
            [attr.aria-haspopup]="hasDeleteConfirmation ? 'dialog' : 'false'">
            <span>
              <mat-icon
                [class]="'adp-ds-icon-wrapper'"
                style="display: flex; width: 16px !important; height: 16px !important"
                width="16"
                height="16"
                svgIcon="device-delete"></mat-icon>
            </span>
          </button>
          <span *ngIf="!hasDelete && !hasEdit" style="display: inline-flex; height: 16px"></span>
        </div>
      </div>
      <div class="ui-grid-grid-sm-12 ui-grid-item ui-grid">
        <span>
          <!--<mat-icon style="color: #3c4d6a; width: 112px !important; height: 112px !important; margin-top: 4px;" *ngIf="isAddDeviceCard" width="112" height="112" svgIcon="device-add-circle"></mat-icon>-->
          <mat-icon
            style="color: #3c4d6a; width: 112px !important; height: 112px !important; margin-top: 4px"
            *ngIf="!isAddDeviceCard"
            width="112"
            height="112"
            svgIcon="{{ icon }}"></mat-icon>
        </span>
      </div>
      <div #contentBody class="device-content-body">
        <div class="ui-grid-grid-sm-12 ui-grid-item device-card-row">
          <ng-container *ngTemplateOutlet="isDeviceDetailsCard ? StaticView : ActionView"></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #ActionView>
  <div
    class="ui-grid-grid-sm-12 ui-grid-item device-card-text"
    [ngClass]="!title ? 'device-card-row-mobile-small' : 'device-card-row-mobile-large'">
    <!--<div *ngIf="isPhoneTemplate && !isPhoneRegistered" class="not-registered-mobile-container">
        <div *ngIf="!isPhoneRegistered" style="display: flex;flex-direction: row;">
          <mat-icon *ngIf="!phoneTestFailed" style="color:orange;font-size:16px;padding-top:2px;">fiber_manual_record</mat-icon>
          <span *ngIf="!phoneTestFailed" style="white-space:nowrap;font-size:14px;font-weight:400;color:#3D515A;"><adp-label labelKey="DeviceCard_Diagnostic_NeedsTesting_Label"></adp-label></span>
          <mat-icon *ngIf="phoneTestFailed" style="color:red;font-size:16px;padding-top:2px;">fiber_manual_record</mat-icon>
          <span *ngIf="phoneTestFailed" style="font-size:14px;font-weight:400;color:#3D515A;"><adp-label labelKey="DeviceCard_Diagnostic_FailedTest_Label"></adp-label></span>
          <button *ngIf="hasDelete" mat-raised-button (click)="handleDeleteActionClick()" class="device-card-phones-button" [attr.aria-label]="deleteIconAriaLabel || undefined" style="margin-left:5px;" [attr.aria-haspopup]="hasDeleteConfirmation?'dialog':'false'">
            <span>
              <mat-icon [class]="'adp-ds-icon-wrapper'" style="width:16px !important;height:16px !important;" width="16" height="16" svgIcon="device-delete"></mat-icon>
            </span>
          </button>
        </div>
      </div>-->
    <div
      *ngIf="!isAddDeviceCard"
      style="min-height: 26px; line-height: 28px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden"
      class="device-card-nickname-container">
      <span matTooltip="{{ title }}" [matTooltipPosition]="'above'">{{ title }}</span>
    </div>
    <div *ngIf="isPhoneTemplate" class="phonePlacement" style="font-weight: 600">
      <span>{{ phoneNumber }}</span>
    </div>
    <div *ngIf="!isPhoneTemplate" class="phonePlacement">
      <!-- TODO: Need to revisit this spot in card once wifi diagnostics is in place, removed the 'cellular-enabled' tag but need a replacement for the space, showing imei number for now-->
      <!--<span *ngIf="deviceIMEINumber">&nbsp;</span>
        <span *ngIf="!deviceIMEINumber">&nbsp;</span>-->
      <div
        style="text-overflow: ellipsis; overflow: hidden; max-height: 56px"
        matTooltip="{{ deviceDetails?.actionLink }}"
        [matTooltipPosition]="'above'">
        <span
          *ngIf="isSelectDeviceView && !isAddDeviceCard"
          style="display: -webkit-inline-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical"
          >{{ deviceDetails.actionLink }}</span
        >
        <span
          *ngIf="!isSelectDeviceView && !isAddDeviceCard"
          style="display: -webkit-inline-box; -webkit-line-clamp: 1; line-clamp: 1; -webkit-box-orient: vertical; font-weight: 600"
          >{{ deviceDetails.actionLink }}</span
        >
      </div>
    </div>
    <div
      *ngIf="isAddDeviceCard"
      [ngStyle]="{ 'margin-bottom': !title ? '10px' : '' }"
      style="line-height: 28px; margin-bottom: 12px"
      class="device-card-nickname-container-mobile">
      <span>{{ title }}</span>
    </div>
  </div>
  <div class="ui-grid-item ui-grid-grid-sm-12 device-card-row device-card-row-alt">
    <div class="ui-grid-grid-sm-12 ui-grid-item device-card-text">
      <div style="text-align: center">
        <button
          *ngIf="!isAddDeviceCard"
          matTooltip="{{ actionLink }}"
          [matTooltipPosition]="'above'"
          style="text-overflow: ellipsis; overflow: hidden; max-height: 56px"
          (click)="handleViewActionClick()"
          [gtmClick]="actionLink"
          class="button-link"
          attr.aria-label="{{ ariaLabel }}"
          role="link">
          <span
            *ngIf="isSelectDeviceView"
            style="display: -webkit-inline-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical"
            >{{ actionLink }}</span
          >
          <span
            *ngIf="!isSelectDeviceView"
            style="display: -webkit-inline-box; -webkit-line-clamp: 1; line-clamp: 1; -webkit-box-orient: vertical"
            >{{ actionLink }}</span
          >
        </button>
        <button
          *ngIf="isAddDeviceCard"
          matTooltip="{{ actionLink }}"
          role="link"
          (click)="handleAddActionClick()"
          [gtmClick]="actionLink"
          class="button-link"
          attr.aria-label="{{ ariaLabel }}"
          [ngClass]="'add-device-card-text-button'"
          >
          <div style="display: flex;">
            <div><mat-icon style="height: 16px;width: 17px;margin-top: 6px;margin-right:6px;"><ng-container *ngTemplateOutlet="addDeviceIcon"></ng-container></mat-icon></div>
            <div>{{ actionLink }}</div>
          </div>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #StaticView>
  <div class="ui-grid-item ui-grid-grid-sm-12 device-card-row device-card-row-alt">
    <div class="ui-grid-grid-sm-12 ui-grid-item device-card-text">
      <div style="text-align: center">
        <div
          *ngIf="!isAddDeviceCard"
          style="text-align: center; font-weight: 600; line-height: 28px"
          class="device-card-nickname-container">
          {{ actionLink }}
        </div>
      </div>
    </div>
  </div>
  <div
    class="ui-grid-grid-sm-12 ui-grid-item device-card-text"
    [ngClass]="!title ? 'device-card-row-mobile-small' : 'device-card-row-mobile-large'">
    <div *ngIf="!isAddDeviceCard" style="text-align: center; line-height: 28px; white-space: nowrap" class="device-card-nickname-container">
      <span style="font-weight: 700">Name: </span>{{ title }}
    </div>
  </div>
</ng-template>

<ng-template #SelectView>
  <div
    class="ui-grid-grid-sm-12 ui-grid-item device-card-text"
    [ngClass]="!title ? 'device-card-row-mobile-small' : 'device-card-row-mobile-large'">
    <div
      *ngIf="!isAddDeviceCard"
      style="line-height: 28px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden"
      class="device-card-nickname-container">
      <span *ngIf="!isEprismDevice" matTooltip="{{ title }}" [matTooltipPosition]="'above'">{{ title }}</span>
      <span *ngIf="isEprismDevice" style="white-space: wrap;display: -webkit-inline-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical;" matTooltip="{{ title }}" [matTooltipPosition]="'above'">{{ title }}</span>
    </div>
    <div
      *ngIf="isAddDeviceCard"
      [ngStyle]="{ 'margin-bottom': !title ? '10px' : '' }"
      style="line-height: 28px; margin-bottom: 12px"
      class="device-card-nickname-container-mobile">
      <span>{{ title }}</span>
    </div>
  </div>
  <div class="ui-grid-item ui-grid-grid-sm-12 device-card-row device-card-row-alt">
    <div class="ui-grid-grid-sm-12 ui-grid-item device-card-text">
      <div class="device-card-text-container">
        <div [ngStyle]="{ 'margin-bottom': !title ? '10px' : '' }" style="line-height: 28px; margin-bottom: 12px">
          <span
            *ngIf="isSelectDeviceView"
            matTooltip="{{ actionLink }}"
            [matTooltipPosition]="'above'"
            style="display: -webkit-inline-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; font-weight: 600"
            >{{ actionLink }}</span
          >
          <span
            *ngIf="!isSelectDeviceView"
            matTooltip="{{ actionLink }}"
            [matTooltipPosition]="'above'"
            style="display: -webkit-inline-box; -webkit-line-clamp: 1; line-clamp: 1; -webkit-box-orient: vertical; font-weight: 600"
            >{{ actionLink }}</span
          >
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div
  *ngIf="isSelectDeviceView && !isPhoneTemplate && !isCellularEnabledTemplate"
  class="pgh-adp-device-card unfocusable"
  tabindex="-1"
  cdkMonitorSubtreeFocus>
  <div
    class="device-card-container clickable"
    tabindex="0"
    (keypress)="handleSelectActionClick()"
    (mouseup)="handleMouseUpClick()"
    (mousedown)="handleMouseDownClick(e)"
    (click)="handleSelectActionClick()"
    [ngClass]="[hasBoxShadow === false ? 'noboxshadow' : '', cardStyle]"
    [ngStyle]="{ background: isBackgroundColorOverride ? backgroundColor : '' }"
    [gtmClick]="title"
    [gtmLinkURL]="urlClaimsSupport()">
    <div class="device-card-body">
      <div class="device-card-row device-card-row-layout device-card-row-mobile" style="align-items: flex-end">
        <div>
          <span style="display: inline-flex; height: 16px"></span>
        </div>
      </div>
      <div class="ui-grid-grid-sm-12 ui-grid-item ui-grid">
        <span>
          <!--<mat-icon *ngIf="isAddDeviceCard" style="color: #3c4d6a; width: 112px !important; height: 112px !important;" width="112" height="112" svgIcon="device-add-circle"></mat-icon>-->
          <mat-icon
            *ngIf="!isAddDeviceCard"
            width="112"
            height="112"
            style="color: #3c4d6a; width: 112px !important; height: 112px !important"
            svgIcon="{{ icon }}"></mat-icon>
        </span>
      </div>
      <div #contentBody class="device-content-body">
        <div class="ui-grid-grid-sm-12 ui-grid-item device-card-row">
          <ng-container *ngTemplateOutlet="SelectView"></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="!isSelectDeviceView && (isPhoneTemplate || isCellularEnabledTemplate)"
  class="pgh-adp-device-card"
  tabindex="-1"
  cdkMonitorSubtreeFocus>
  <div
    class="device-card-container"
    [ngClass]="hasBoxShadow === false ? 'noboxshadow' : ''"
    [ngStyle]="{ background: isBackgroundColorOverride ? backgroundColor : '', display: isPhoneRegistered ? 'flex;' : '' }">
    <div class="device-card-body" style="width: 100%">
      <div
        [ngClass]="!isPhoneRegistered ? 'device-card-diagnostic-row-mobile' : 'device-card-row-mobile'"
        class="device-card-row device-card-row-layout"
        [ngStyle]="{ 'align-items': isPhoneRegistered ? 'flex-end;' : 'center;', 'margin-top': isPhoneRegistered ? '5px;' : '2px;' }">
        <div style="width: 100%">
          <button
            *ngIf="hasEdit && isPhoneRegistered"
            mat-raised-button
            (click)="handleEditActionClick()"
            [gtmClick]="editIconAriaLabel"
            class="device-card-button"
            [attr.aria-label]="editIconAriaLabel || undefined">
            <span>
              <mat-icon
                [class]="'adp-ds-icon-wrapper'"
                style="width: 16px !important; height: 16px !important"
                width="16"
                height="16"
                svgIcon="device-edit"></mat-icon>
            </span>
          </button>
          <div *ngIf="hasDelete && isPhoneRegistered" style="display: flex">
            <div style="width: 100%; margin-bottom: 2px"></div>
            <button
              *ngIf="hasDelete && isPhoneRegistered"
              mat-raised-button
              (click)="handleDeleteActionClick()"
              [gtmClick]="deleteIconAriaLabel"
              class="device-card-button"
              [attr.aria-label]="deleteIconAriaLabel || undefined"
              [attr.aria-haspopup]="hasDeleteConfirmation ? 'dialog' : 'false'">
              <span>
                <mat-icon
                  [class]="'adp-ds-icon-wrapper'"
                  style="display: flex; width: 16px !important; height: 16px !important"
                  width="16"
                  height="16"
                  svgIcon="device-delete"></mat-icon>
              </span>
            </button>
          </div>
          <span *ngIf="!hasDelete && !hasEdit && isPhoneRegistered" style="display: inline-flex; height: 16px"></span>
          <div *ngIf="!isPhoneRegistered" style="display: flex; flex-direction: row; margin-top: 3px" class="not-registered-lg-container">
            <mat-icon *ngIf="!phoneTestFailed" style="color: orange; font-size: 16px; padding-top: 2px; margin-right: 6px"
              >fiber_manual_record</mat-icon
            >
            <span
              *ngIf="!phoneTestFailed"
              class="diagnostic-row-mobile"
              style="white-space: nowrap; font-size: 14px; font-weight: 400; color: #3d515a"
              ><adp-label labelKey="DeviceCard_Diagnostic_NeedsTesting_Label"></adp-label
            ></span>
            <mat-icon *ngIf="phoneTestFailed" style="color: red; font-size: 16px; padding-top: 2px; margin-right: 6px"
              >fiber_manual_record</mat-icon
            >
            <span
              *ngIf="phoneTestFailed"
              class="diagnostic-row-mobile"
              style="white-space: nowrap; font-size: 14px; font-weight: 400; color: #3d515a"
              ><adp-label labelKey="DeviceCard_Diagnostic_FailedTest_Label"></adp-label
            ></span>
            <!-- TODO: Need to address adding bin icon and transition Manage Invite to View Details -->
            <div style="width: 100%"></div>
            <div>
              <button
                mat-raised-button
                (click)="handleDeleteActionClick()"
                [gtmClick]="deleteIconAriaLabel"
                class="device-card-phones-button"
                [attr.aria-label]="deleteIconAriaLabel || undefined"
                [attr.aria-haspopup]="hasDeleteConfirmation ? 'dialog' : 'false'">
                <span>
                  <mat-icon
                    [class]="'adp-ds-icon-wrapper'"
                    style="display: flex; width: 16px !important; height: 16px !important"
                    width="16"
                    height="16"
                    svgIcon="device-delete"></mat-icon>
                </span>
              </button>
            </div>
          </div>

          <!-- TODO Determine where to place this div -->
          <div *ngIf="(isPhoneTemplate || isCellularEnabledTemplate) && !isPhoneRegistered" class="not-registered-mobile-container">
            <div *ngIf="!isPhoneRegistered" style="display: flex; flex-direction: row; margin-top: 3px">
              <mat-icon *ngIf="!phoneTestFailed" style="color: orange; font-size: 16px; padding-top: 2px">fiber_manual_record</mat-icon>
              <span
                *ngIf="!phoneTestFailed"
                class="diagnostic-row-mobile"
                style="white-space: nowrap; font-size: 14px; font-weight: 400; color: #3d515a"
                ><adp-label labelKey="DeviceCard_Diagnostic_NeedsTesting_Label"></adp-label
              ></span>
              <mat-icon *ngIf="phoneTestFailed" style="color: red; font-size: 16px; padding-top: 2px">fiber_manual_record</mat-icon>
              <span
                *ngIf="phoneTestFailed"
                class="diagnostic-row-mobile"
                style="white-space: nowrap; font-size: 14px; font-weight: 400; color: #3d515a"
                ><adp-label labelKey="DeviceCard_Diagnostic_FailedTest_Label"></adp-label
              ></span>
              <div style="width: 100%"></div>
              <div>
                <button
                  *ngIf="hasDelete"
                  mat-raised-button
                  (click)="handleDeleteActionClick()"
                  [gtmClick]="deleteIconAriaLabel"
                  class="device-card-phones-button"
                  [attr.aria-label]="deleteIconAriaLabel || undefined"
                  [attr.aria-haspopup]="hasDeleteConfirmation ? 'dialog' : 'false'">
                  <span>
                    <mat-icon
                      [class]="'adp-ds-icon-wrapper'"
                      style="width: 16px !important; height: 16px !important"
                      width="16"
                      height="16"
                      svgIcon="device-delete"></mat-icon>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ui-grid-grid-sm-12 ui-grid-item ui-grid">
        <span *ngIf="!isPhoneRegistered">
          <mat-icon
            style="color: #3c4d6a; width: 112px !important; height: 112px !important"
            *ngIf="!isAddDeviceCard"
            width="112"
            height="112"
            svgIcon="{{ icon }}"></mat-icon>
        </span>
        <span *ngIf="isPhoneRegistered">
          <mat-icon
            style="color: #3c4d6a; width: 112px !important; height: 112px !important; margin-top: 4px !important"
            *ngIf="!isAddDeviceCard"
            width="112"
            height="112"
            svgIcon="{{ icon }}"></mat-icon>
        </span>
      </div>

      <div #contentBody class="device-content-body">
        <div class="ui-grid-grid-sm-12 ui-grid-item device-card-row">
          <ng-container *ngTemplateOutlet="isDeviceDetailsCard ? StaticView : ActionView"></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="isSelectDeviceView && (isPhoneTemplate || isCellularEnabledTemplate)"
  class="pgh-adp-device-card unfocusable"
  tabindex="-1"
  cdkMonitorSubtreeFocus>
  <div
    class="device-card-container clickable"
    tabindex="0"
    (keypress)="handleSelectActionClick()"
    (mouseup)="handleMouseUpClick()"
    (mousedown)="handleMouseDownClick(e)"
    (click)="handleSelectActionClick()"
    [ngClass]="[hasBoxShadow === false ? 'noboxshadow' : '', cardStyle]"
    [ngStyle]="{ background: isBackgroundColorOverride ? backgroundColor : '' }"
    [gtmClick]="title">
    <div class="device-card-body">
      <div class="device-card-row device-card-row-layout device-card-row-mobile" style="align-items: flex-end">
        <div>
          <span style="display: inline-flex; height: 16px"></span>
        </div>
      </div>
      <div class="ui-grid-grid-sm-12 ui-grid-item ui-grid">
        <span>
          <!--<mat-icon *ngIf="isAddDeviceCard" style="color: #3c4d6a; width: 112px !important; height: 112px !important;" width="112" height="112" svgIcon="device-add-circle"></mat-icon>-->
          <mat-icon
            *ngIf="!isAddDeviceCard"
            width="112"
            height="112"
            style="color: #3c4d6a; width: 112px !important; height: 112px !important"
            svgIcon="{{ icon }}"></mat-icon>
        </span>
      </div>
      <div #contentBody class="device-content-body">
        <div class="ui-grid-grid-sm-12 ui-grid-item device-card-row">
          <ng-container *ngTemplateOutlet="SelectView"></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addDeviceIcon>
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.83504 0.0239362C7.7007 0.0718562 7.59875 0.170112 7.53084 0.317104L7.49587 0.392832L7.49163 3.94059L7.48739 7.48835L3.93963 7.49259L0.391869 7.49683L0.301501 7.5392C0.196013 7.58866 0.0957888 7.68314 0.0458848 7.78018C-0.00709116 7.88317 -0.0135872 8.06146 0.0312768 8.18037C0.0749248 8.29605 0.179197 8.40515 0.300349 8.46194L0.391869 8.50483L3.93963 8.50907L7.48739 8.51331L7.49163 12.0611L7.49587 15.6088L7.53876 15.7004C7.72628 16.1004 8.27345 16.1004 8.46097 15.7004L8.50387 15.6088L8.50811 12.0611L8.51235 8.51331L12.0601 8.50907L15.6079 8.50483L15.6994 8.46194C15.8137 8.40835 15.9247 8.29587 15.9613 8.19666C15.9766 8.15496 15.9952 8.11398 16.0025 8.10563C16.0195 8.08629 16.0202 7.86827 16.0032 7.87875C15.9963 7.88306 15.9782 7.85165 15.963 7.80894C15.9272 7.70802 15.8158 7.59429 15.6994 7.53973L15.6079 7.49683L12.0601 7.49259L8.51235 7.48835L8.50811 3.94059L8.50387 0.392832L8.46097 0.301312C8.40478 0.18144 8.29488 0.0757442 8.1828 0.0338082C8.08044 -0.0044798 7.92694 -0.0088478 7.83504 0.0239362ZM0.00524484 8.00083C0.00524484 8.06683 0.00807684 8.09384 0.0115168 8.06083C0.0149728 8.02784 0.0149728 7.97384 0.0115168 7.94083C0.00807684 7.90784 0.00524484 7.93483 0.00524484 8.00083Z" fill="#0066CC"/>
</svg>
</ng-template>
